import type { Component } from '../../../schemas/validation';
import { createContext, useContext } from 'react';

export interface LinkTargetPageContextValue {
  /** Page being edited — used to avoid refetch when picking sections on this page */
  currentPageId?: string;
  /** Same page as URL slug — fallback when IDs from different APIs diverge slightly */
  currentPageSlug?: string;
  /** Layout chrome above page body (anchors exist in DOM on the rendered page). */
  layoutLinkHeaderComponents?: Component[];
  /** Layout chrome below page body — e.g. custom HTML/embed in footer. */
  layoutLinkFooterComponents?: Component[];
}

const LinkTargetPageContext = createContext<LinkTargetPageContextValue>({});

export const LinkTargetPageProvider = LinkTargetPageContext.Provider;

export function useLinkTargetPageContext(): LinkTargetPageContextValue {
  return useContext(LinkTargetPageContext);
}
